var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateNoteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECEDF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 23.5H26.5V25H5.5V23.5ZM23.05 10.75C23.65 10.15 23.65 9.25 23.05 8.65L20.35 5.95C19.75 5.35 18.85 5.35 18.25 5.95L7 17.2V22H11.8L23.05 10.75ZM19.3 7L22 9.7L19.75 11.95L17.05 9.25L19.3 7ZM8.5 20.5V17.8L16 10.3L18.7 13L11.2 20.5H8.5Z",
    fill: "#96A0BC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateNoteIcon);
export default __webpack_public_path__ + "static/media/updateNoteIcon.59006fdd5db25e0f4854c79fdc531996.svg";
export { ForwardRef as ReactComponent };